import React, { useState, useEffect } from 'react';
import styles from './offer-approvals.module.scss';
import ReactGA from 'react-ga';
import { Helmet } from "react-helmet";
import CustomNavbar from '../../customNavbar';
import { Accordion, Card, Col, Row, Button, Container, Image } from 'react-bootstrap';
import MaterialTable from 'material-table';
import { dropdownIcon } from '../../../shared/customIcons/Icons';
import { Formik } from 'formik';
import * as yup from 'yup';
import { CustomButton } from '../../../shared/customButton';
import { getExternalAssessmentsByGroup, submitExternalAssessmentReview } from '../../../../services/util/externalAssessments';
import { getAssignedOfferApprovals, approveOffer, rejectOffer } from '../../../../services/util/approvals';
import CSSLoader from '../../../shared/cssLoader';
import { CustomAlertBox } from '../../../shared/customAlertBox';
import { CustomConfirmationBox } from '../../../shared/customConfirmationBox';
import { CustomConfirmationModal } from '../../../shared/customConfirmationModal';
import { CustomStatusLabel } from '../../../shared/customStatusLabel';
import { CustomIconButton } from '../../../shared/customIconButton';
import { CustomPreIcon } from '../../../shared/customPreIcon';
import { CustomSearch } from '../../../shared/customSearch';
import Avatar from 'react-avatar';

import { Icon } from '@material-ui/core';


function ViewOtherReviews(props) {
    let [accordionIcon, setAccordionIcon] = useState(true);
    let [sideBarOpen, setSideBar] = useState(false);


    let [showRejectConfirmationModal, setShowRejectConfirmationModal] = useState(false);
    let [showApproveConfirmationModal, setShowApproveConfirmationModal] = useState(false);
    let [modalActionButtonLoading, setModalActionButtonLoading] = useState(false);
    let [selectedCandidateName, setSelectedCandidateName] = useState('');

    let [selectedOfferSession, setSelectedOfferSession] = useState({})


    let [offerApprovalList, setofferApprovalList] = useState([]);
    const [isSubmitLoading, setSubmitLoading] = useState(false)
    const [isLoading, setLoading] = useState(false);
    let [getUsersIsLoading, getUsersSetLoading] = useState(false);

    const breadcrumb = [
        {
            pathaddress: '/app/company/external-assessments',
            pathname: 'External Assessments',
            isActive: false,
            key: 1 + 'External Assessments'
        },
        {
            pathaddress: '',
            // pathname: commonData.step_name,
            isActive: true,
            // key: 1 + commonData.step_name
        }
    ];



    const handleClose = () => {
        setShowRejectConfirmationModal(false);
        setShowApproveConfirmationModal(false);
        setSelectedCandidateName('');
    }

    const onClickApprove = async (name) => {
        setSelectedCandidateName(selectedOfferSession.candidate_name);
        setShowApproveConfirmationModal(true);
    }

    function onClickReject(name) {
        setSelectedCandidateName(selectedOfferSession.candidate_name);
        setShowRejectConfirmationModal(true);
    }

    const submitRejectOffer = async (values) => {
        setModalActionButtonLoading(true);
        let respond = await rejectOffer(selectedOfferSession.offer_session_id, values.reason);
        if (respond.success === true) {
            await loadInitialData()
            closeSideBar();
            handleClose();
            props.main_props.GetTaskValues();
            setModalActionButtonLoading(false);
        } else {
            setModalActionButtonLoading(false);
        }
    }


    const submitApproveOffer = async () => {
        setModalActionButtonLoading(true);
        let respond = await approveOffer(selectedOfferSession.offer_session_id);
        if (respond.success === true) {
            await loadInitialData()
            closeSideBar();
            handleClose();
            props.main_props.GetTaskValues();
            setModalActionButtonLoading(false);
        } else {
            setModalActionButtonLoading(false);
        }
    }



    async function loadInitialData() {
        setLoading(true);
        let respond = await getAssignedOfferApprovals();
        if (respond.success === true) {
            setofferApprovalList(respond.data);
            setLoading(false);
            // setModalOpen(true);
        } else {
            setLoading(false);
        }
    }


    const viewOffer = (values) => {

        setSelectedOfferSession(values)
        setSideBar(true);
    }

    const closeSideBar = () => {
        setSelectedOfferSession({})
        setSideBar(false);
    }

    const removeCompanyAlert = (index) => {
        let new_array = props.main_props.userAlerts;
        new_array.splice(index, 1);
        props.setUserAlerts(new_array);
        loadInitialData();
    }

    //view candidate
    function viewCandidate(val) {
        let path = `/app/company/candidate`;
        let search = 'cid=' + val;

        const url = `${path}?${search}`;
        window.open(url);
    }

    const itemsPerPage = 9; // Number of items to display per page
    const [currentPage, setCurrentPage] = useState(1); // Current page number

    const handlePreviousClick = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextClick = () => {
        const totalPages = Math.ceil(offerApprovalList.length / itemsPerPage);
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };
    const totalPages = Math.ceil(offerApprovalList.length / itemsPerPage);

    useEffect(() => {
        loadInitialData();
    }, [])

    useEffect(() => {
        let pageHit = '/app/company/approvals';
        // props.toggleInterviewView(false);
        ReactGA.initialize(`${process.env.REACT_APP_GOOGLE_ANALYTICS_ID}`);
        ReactGA.pageview(pageHit);
    }, [])


    return (
        <div>
            <Helmet>
                <title>Offer Approvals | HireTrace</title>
            </Helmet>
            {isLoading ?
                <div className={styles.loadingDiv}>
                    <Col sm={{ span: 4, offset: 4 }}>
                        <CSSLoader />
                    </Col>
                </div>
                :
                <div>
                    <CustomConfirmationBox
                        show={showRejectConfirmationModal}
                        cancelIconclick={handleClose}
                        onSecondaryBtnClick={handleClose}
                        onFormSubmit={submitRejectOffer}
                        isSecondaryBtnDisabled={modalActionButtonLoading === true ? true : false}
                        isPrimaryBtnDisabled={modalActionButtonLoading === true ? true : false}
                        primaryBtnBackSideIcon={modalActionButtonLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                        preCheckedCondition={true}
                        topic="Are you sure?"
                        message={`You are trying to reject job offer for ${selectedCandidateName}.`}
                        secondaryBtnName="backBtn"
                        secondaryBtnType="button"
                        secondaryBtnCssType="defaultBtn"
                        secondaryBtnLabel="Cancel"
                        primaryBtnName="submitBtn"
                        primaryBtnType="submit"
                        primaryBtnCssType="dangerBtn"
                        primaryBtnLabel="Yes, reject offer"
                    />

                    <CustomConfirmationModal
                        show={showApproveConfirmationModal}
                        confirmationType='success'
                        cancelIconclick={handleClose}
                        onSecondaryBtnClick={handleClose}
                        onPrimaryBtnClick={submitApproveOffer}
                        isSecondaryBtnDisabled={modalActionButtonLoading === true ? true : false}
                        isPrimaryBtnDisabled={modalActionButtonLoading === true ? true : false}
                        primaryBtnBackSideIcon={modalActionButtonLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                        confirmationTopic="Are you sure?"
                        confirmationMessage={`You are trying to approve job offer for ${selectedCandidateName}.`}
                        secondaryBtnName="backBtn"
                        secondaryBtnType="button"
                        secondaryBtnCssType="primaryBtn"
                        secondaryBtnLabel="Cancel"
                        primaryBtnName="submitBtn"
                        primaryBtnType="button"
                        primaryBtnCssType="successBtn"
                        primaryBtnLabel="Yes, approve offer!"
                    />

                    <div className={sideBarOpen === true ? `${styles.sidenav} ${styles.sidenavOpen}` : styles.sidenav}>
                        <div className={styles.sideNavBody}>
                            <div className={styles.modalCancelBtnDiv}>
                                <Button className={styles.modalCancelBtn} onClick={() => { closeSideBar(); }}>
                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M13.5 4.5L4.5 13.5" stroke="#24859A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M4.5 4.5L13.5 13.5" stroke="#24859A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </Button>
                            </div>
                            <Container className="mt-4">
                                <Col>
                                    <p className={styles.sideBarTopic}>
                                        Review Offer
                                    </p>
                                    <Card className={styles.cardOuterBox}>
                                        <Card.Body >
                                            <div className={styles.cardTitleBox}>
                                                <Row>
                                                    <Col sm={2}>
                                                        <Avatar name={selectedOfferSession.candidate_name} size="32" round={true} />
                                                    </Col>
                                                    <Col sm={6}>
                                                        <Row className={styles.tableJobDetailsRow}>
                                                            <p className={styles.tableJobDetails}>{selectedOfferSession.candidate_name}</p>
                                                        </Row>
                                                        <Row className={styles.tableJobDetailsRow}>
                                                            <p className={styles.tableSecondJobDetails}>{selectedOfferSession?.email}</p>
                                                        </Row>
                                                    </Col>
                                                    <Col sm={4} className='d-flex align-items-center justify-content-center'>
                                                        <CustomStatusLabel type={(selectedOfferSession.state === 10 || selectedOfferSession.state === 20 || selectedOfferSession.state === 30) ? 'successStatus' : (selectedOfferSession.state === 0) ? 'warningStatus' : (selectedOfferSession.state === -10 || selectedOfferSession.state === -20 || selectedOfferSession.state === -30) ? 'dangerStatus' : 'null'} label={selectedOfferSession.state === 10 ? 'Approved' : selectedOfferSession.state === 20 ? 'Offer Sent' : selectedOfferSession.state === 0 ? 'Pending Approval' : selectedOfferSession.state === 30 ? 'Marked as Offer Accepted' : selectedOfferSession.state === -10 ? 'Approval Rejected' : selectedOfferSession.state === -20 ? 'Marked as Candidate Rejected' : selectedOfferSession.state === -30 ? 'Offer Retracted' : null}></CustomStatusLabel>
                                                    </Col>
                                                </Row>
                                            </div>
                                            <hr className={styles.horizontalDivider} />

                                            <div>
                                                <div>
                                                    <p className={styles.subTopic}>
                                                        Vacancy Details
                                                    </p>
                                                    <div>
                                                        <Row>
                                                            <Col className="text-left">
                                                                <Row>
                                                                    <Col>
                                                                        <p className={styles.attributeValue}>{selectedOfferSession.job_type === 10 ? "Full-Time" : selectedOfferSession.job_type === 20 ? "Part-Time" : selectedOfferSession.job_type === 30 ? "Contact/Temp" : selectedOfferSession.job_type === 50 ? "Casual / Vacation" : ''} . {selectedOfferSession.work_type === 10 ? "Remote" : selectedOfferSession.work_type === 20 ? "On-Site" : selectedOfferSession.work_type === 30 ? "Hybrid" : ''} . {selectedOfferSession.location}</p>
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                    <div>
                                                        <Row>
                                                            <Col className="text-left">
                                                                <Row>
                                                                    <Col>
                                                                        <p className={styles.attributeLabel}>Hiring Pipeline Name - {selectedOfferSession.pipeline_name}</p>
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </div>

                                            </div>

                                            <hr className={styles.horizontalDivider} />

                                            <div>
                                                <p className={styles.subTopic}>
                                                    Offer Details
                                                </p>

                                                <div>
                                                    <Row>
                                                        <Col className="text-left">
                                                            <Row>
                                                                <Col lg={4}>
                                                                    <p className={styles.attributeLabel}>Job Title</p>
                                                                </Col>
                                                                <Col className="text-left">
                                                                    <p className={styles.attributeValue}>{selectedOfferSession.job_title}</p>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col lg={4}>
                                                                    <p className={styles.attributeLabel}>Allocation</p>
                                                                </Col>
                                                                <Col className="text-left">
                                                                    <p className={styles.attributeValue}>{selectedOfferSession.allocation}</p>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col lg={4}>
                                                                    <p className={styles.attributeLabel}>Description</p>
                                                                </Col>
                                                                <Col className="text-left">
                                                                    <p className={styles.attributeValue}>{selectedOfferSession.description}</p>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col lg={4}>
                                                                    <p className={styles.attributeLabel}>Package Reference</p>
                                                                </Col>
                                                                <Col className="text-left">
                                                                    <p className={styles.attributeValue}>{selectedOfferSession.package_reference}</p>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                </div>
                                                <div className={styles.buttonsSection}>

                                                    <Row>
                                                        <Col>
                                                            <CustomButton
                                                                name="submitBtn"
                                                                buttonType="button"
                                                                label="Reject"
                                                                handleClick={onClickReject}
                                                                type="dangerBtn"
                                                            />
                                                        </Col>
                                                        <Col className="pl-0">
                                                            <CustomButton
                                                                name="submitBtn"
                                                                buttonType="button"
                                                                type="primaryBtn"
                                                                label="Approve"
                                                                handleClick={onClickApprove}
                                                            />
                                                        </Col>
                                                    </Row>

                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Card>

                                </Col>
                            </Container>
                        </div>
                    </div >

                    <div className={styles.BodyContainer} >
                        <Row>
                            <Col>

                                {((offerApprovalList.length === 0) && (isLoading === false)) ?

                                    (<div>
                                        <Col>
                                            <p className={styles.infoMessage}>Currently no pending job offers waiting for your approval. Learn more
                                                about  <a href='https://hiretrace.io/documentation/job-offers/overview' target="_blank">Job Offers</a>. </p>
                                        </Col>
                                        <Col xs={{ span: 6, offset: 3 }} sm={{ span: 4, offset: 4 }}>
                                            <Image src={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/noOffers.svg`} fluid />
                                        </Col>
                                    </div>)
                                    :

                                    (<div className={styles.tableContainer}>
                                        <div className={styles.tableFirstRowMainHeaderDiv}>
                                            <Col sm={4} className={styles.tablePipelineDetailsMainHeaderRow}>
                                                <p>Candidate Details</p>
                                            </Col>
                                            <Col sm={2}>
                                                <Row className={styles.tableInfoDetailsMainHeaderRow}>
                                                    <p>Job Title/Allocation</p>
                                                </Row>
                                            </Col>
                                            <Col sm={2}>
                                                <Row className={styles.tableShareLinksHeaderRow}>
                                                    <p>Position/Pipeline</p>
                                                </Row>
                                            </Col>
                                            <Col sm={1}></Col>
                                            <Col sm={3}>
                                                <Row className={styles.tableCandidatesInfoDetailsHeaderRow}>
                                                    <p>Review</p>
                                                </Row>
                                            </Col>
                                        </div>
                                        {offerApprovalList?.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage).map((approval, i) => {
                                            return (
                                                <div className={i % 2 === 0 ? styles.tableRowMainDiv : styles.tableRowSecondMainDiv}>
                                                    <Col sm={4}>
                                                        <Row className={styles.tableJobDetailsMainRow}>
                                                            <Col sm={2}>
                                                                <Avatar name={approval.candidate_name} size="32" round={true} />
                                                            </Col>
                                                            <Col sm={10}>
                                                                <Row className={styles.tableJobDetailsRow}>
                                                                    <p className={styles.tableJobDetails}>{approval?.candidate_name}</p>
                                                                </Row>
                                                                <Row className={styles.tableJobDetailsRow}>
                                                                    <p className={styles.tableSecondJobDetails}>{approval?.email}</p>
                                                                </Row>
                                                            </Col>

                                                        </Row>

                                                    </Col>
                                                    <Col sm={2}>
                                                        <div className={styles.tableJobPositionMainRow}>
                                                            <Row className={styles.tableJobDetailsRow}>
                                                                <p className={styles.tableJobDetails}>{approval.job_title}</p>
                                                            </Row>
                                                            <Row className={styles.tableJobDetailsRow}>
                                                                <p className={styles.tableSecondJobDetails}>{approval?.allocation}</p>
                                                            </Row>
                                                        </div>

                                                    </Col>
                                                    <Col sm={2}>
                                                        <Row className={styles.tableCandidatesInfoDetailsRow}>
                                                            <p className={styles.tableCandidatesInfoDetails}>{approval.hiring_position}</p>
                                                        </Row>
                                                    </Col>
                                                    <Col sm={1}></Col>
                                                    <Col sm={3}>
                                                        <Row className={styles.tableCandidatesInfoDetailsButtonRow}>
                                                            <CustomButton
                                                                buttonType="button"
                                                                label="Review Candidate"
                                                                type="secondaryBtn"
                                                                backicon={
                                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                        <path d="M9 12L12 9L9 6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                        <path d="M6 9H12" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                    </svg>
                                                                }
                                                                handleClick={() => { viewOffer(approval) }}
                                                            />
                                                        </Row>
                                                    </Col>

                                                </div>
                                            );

                                        })
                                        }
                                        {offerApprovalList.length > 9 && getUsersIsLoading === false &&

                                            <div className={styles.bottomTableDiv}>
                                                <div className={styles.bottomTableControlsWrapper}>
                                                    <div className={styles.bottomTableControlsNextBtn}>
                                                        <CustomButton
                                                            id="offer_approvals_go_to_previous_page_btn"
                                                            label="Previous"
                                                            handleClick={handlePreviousClick}
                                                            disabled={currentPage === 1}
                                                            type="defaultSmallBtn"
                                                        />
                                                    </div>
                                                    <div>
                                                        <CustomButton
                                                            id="offer_approvals_go_to_next_page_btn"
                                                            label="Next"
                                                            type="defaultSmallBtn"
                                                            handleClick={handleNextClick}
                                                            disabled={currentPage === Math.ceil(offerApprovalList.length / itemsPerPage)}
                                                        />
                                                    </div>
                                                </div>
                                                <div>
                                                    <span className={styles.paginationInfo}>
                                                        Page {currentPage} of {totalPages}
                                                    </span>
                                                </div>

                                            </div>
                                        }
                                    </div>)

                                }
                            </Col>
                        </Row>
                    </div >
                </div >
            }
        </div >
    )
}

export default ViewOtherReviews;
